import { trendingTopics } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function TopicBuzz() {
  return (
    <section
      id="buzz"
      className="bg-background-100 px-6 lg:px-10 py-14 md:py-20 border-y border-background-200 scroll-mt-24"
    >
      <SectionHeading
        index="06"
        label="Now Discussing"
        title="大家正在讨论的话题"
        desc="不知道从哪切入的时候，跟着讨论走也不错。这些是最近被提起最多的话题方向。"
      />

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
        {trendingTopics.map((topic, i) => (
          <a
            key={topic.name}
            href="#hot"
            className="flex items-center gap-4 py-3.5 border-b border-background-200 cursor-pointer group"
          >
            <span
              className={`font-label text-lg w-7 shrink-0 ${
                i < 3 ? "text-primary-500" : "text-foreground-400"
              }`}
            >
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="flex-1 min-w-0">
              <span className="block text-sm md:text-[15px] text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
                # {topic.name}
              </span>
              <div className="mt-2 flex items-center gap-3">
                <div className="h-1.5 flex-1 max-w-[180px] rounded-full bg-background-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${topic.heat}%` }}
                  ></div>
                </div>
                <span className="font-label text-xs text-foreground-500">
                  热度 {topic.heat}
                </span>
              </div>
            </div>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              {topic.posts} 条讨论
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}